module.exports = __webpack_public_path__ + "img/rectangle-3.361fc65a.svg";